import { CALL_API, Schemas } from '../../common/middleware/api';

export const HOW_YOU_LEARN_REQUEST = 'HOW_YOU_LEARN_REQUEST';
export const HOW_YOU_LEARN_SUCCESS = 'HOW_YOU_LEARN_SUCCESS';
export const HOW_YOU_LEARN_FAILURE = 'HOW_YOU_LEARN_FAILURE';

export const loadHowYouLearn = (options) => ({
	[CALL_API]: {
		types: [HOW_YOU_LEARN_REQUEST, HOW_YOU_LEARN_SUCCESS, HOW_YOU_LEARN_FAILURE],
		endpoint: 'api/parents',
		request: options,
		schema: Schemas.HOW_YOU_LEARN_ARRAY
	}
});